import * as Constants from './constants';

const SurveyPointMode: any = {};

let point;

SurveyPointMode.onSetup = function () {
    point = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {},
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: [],
        },
    });

    this.addFeature(point);

    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POINT);

    this.setActionableState({
        trash: true,
    });

    setTimeout(() => {
        this.map.fire(Constants.events.CREATE, {
            features: [point.toGeoJSON()],
        });

        this.changeMode(Constants.modes.SIMPLE_SELECT, {
            featureIds: [point.id],
        });
    }, 10);

    return { point };
};

SurveyPointMode.addCoordinates = function (position: GeolocationPosition) {
    point.updateCoordinate(
        '',
        position.coords.longitude,
        position.coords.latitude,
    );
};

SurveyPointMode.toDisplayFeatures = function () {
    return;
};

export default SurveyPointMode;
